<script setup lang="ts">
import { AvionLocationSpace } from '@/entities/AvionLocation'
import { defineProps, PropType } from 'vue'
import { showSpaceSelected } from './helpers'

defineOptions({
  name: 'SpaceCard',
})

defineProps({
  space: {
    type: Object as PropType<AvionLocationSpace>,
    required: true,
  },
})
</script>

<template>
  <article :class="{ selected: showSpaceSelected(space) }">
    <h3>
      <i class="pi pi-box" style="margin-right: 4px" />
      {{ space.name }}
    </h3>
  </article>
</template>

<style scoped>
article {
  box-shadow: var(--card-shadow);
  border-radius: var(--border-radius);
  background-color: #fff;
  padding: var(--section-padding);
}

article.selected {
  background-color: var(--p-indigo-50);
  border: 1px solid var(--p-indigo-400);
}

article h3 {
  margin: 0;
  font-size: 14px;
}
</style>
